import React, { ReactNode, CSSProperties } from 'react';
import { colors, typography } from '../../../tokens';

export interface PageTitleProps {
  children: ReactNode;
  style?: CSSProperties;
  align?: 'left' | 'center' | 'right';
}

export const PageTitle: React.FC<PageTitleProps> = ({
  children,
  style = {},
  align = 'center',
}) => {
  return (
    <h1
      style={{
        fontSize: typography.heading.h1.size,
        fontWeight: typography.fontWeight.extrabold,
        fontFamily: typography.fontFamily.heading,
        color: colors.text.primary.default,
        letterSpacing: typography.letterSpacing.tight,
        lineHeight: typography.heading.h1.lineHeight,
        textAlign: align,
        margin: 0,
        ...style,
      }}
    >
      {children}
    </h1>
  );
};
